import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";

export default {
  icon: LocalShippingOutlinedIcon,
};
